import AdmZip from "adm-zip";

function compressFile(fileContent, fileName) {
    try {
        let zip = new AdmZip();
        zip.addFile(fileName, fileContent);
        return zip;
    } catch (error) {
        console.log(error);
    }
}
function decompressFile(fileData) {
    try {
        const data = [];
        let zip = new AdmZip(fileData);
        const zipEntries = zip.getEntries();
        zipEntries.forEach((zipEntry) => {
            data.push(zip.readAsText(zipEntry));
        });
        return data;
    } catch (error) {
        console.log(error);
    }
}

export { compressFile, decompressFile };
